import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import questionsData from './questions.json';



// Конфигурация сервера
const API_URL = 'https://apiopros2026.cemon.ru/api';

// Максимальное количество попыток отправки
const MAX_RETRIES = 5;
// Задержка между попытками (мс)
const RETRY_DELAYS = [1000, 2000, 3000, 5000, 10000];

// Ключ для хранения ID отправленной анкеты в localStorage
const SUBMITTED_SURVEY_KEY = 'submitted_survey_id';

// ==================== КОНСТАНТЫ ДЛЯ КОДИРОВАНИЯ ОТВЕТОВ ====================
const ENCODE = {
  q5: { 'ежедневно': 1, 'иногда': 2, 'не интересуюсь': 3 },
  q6: { 'отличное': 1, 'хорошее': 2, 'среднее': 3, 'плохое': 4, 'очень плохое': 5 },
  q7: { 'да': 1, 'нет': 2 },
  q22: {
    'съедают почти все (остается менее 20%)': 1,
    'не съедают около 30-40% блюд': 2,
    'высокий уровень несъедаемости (более 50%)': 3,
    'затрудняюсь ответить': 4
  },
  q23: {
    'да, абсолютно доволен': 1,
    'в целом доволен, но иногда высказывает недовольство': 2,
    'нет, мой ребенок совершенно недоволен качеством питания в школе': 3,
    'не знаю': 4
  },
  q24: {
    'практически еженедельно': 1,
    'примерно раз в месяц': 2,
    'раз в полгода и реже': 3,
    'никогда': 4,
    'не знаю': 5
  },
  q27: { 'да': 1, 'нет': 2, 'не знаю': 3, 'у нас в школе нет буфета': 4 },
  q29: {
    'знаю, участвую в контроле': 1,
    'знаю об этом, но не применяли это на практике': 2,
    'не знаю о такой возможности': 3
  },
  q30: {
    'регулярно проверяю': 1,
    'не проверяю': 2,
    'ничего об этом не знаю': 3,
    'в школе не созданы условия для проверки': 4,
    'недостаточно знаний и компетенций': 5,
    'нет времени': 6
  },
  q33: { 'да': 1, 'нет': 2, 'не знаю': 3 },
  q34: { 'да, это эффективная структура': 1, 'нет, считаю эту структуру формальной': 2 },
  q36: { 'регулярно': 1, 'один раз в учебный год и реже': 2, 'не проводятся': 3 },
  q37: { 'да': 1, 'нет': 2, 'мало влияют': 3, 'затрудняюсь ответить': 4 },
  q39: {
    'ежемесячно': 1,
    '1 раз в 3 месяца': 2,
    'раз в полгода': 3,
    'один раз в учебный год': 4,
    'реже одного раза в учебный год': 5,
    'не проводятся': 6
  },
  q41: { 'да, регулярно': 1, 'время от времени': 2, 'нет': 3, 'никогда, не хватает времени': 4 },
  q42: { 'да': 1, 'нет': 2, 'не знаю': 3 },
  // Детские вопросы
  child_q4: {
    'только завтракаю': 1,
    'только обедаю': 2,
    'обедаю и завтракаю': 3,
    'приношу еду из дома': 4,
    'не питаюсь в школе': 5
  },
  child_q5: { 'да': 1, 'иногда бывает недовольство': 2, 'нет': 3, 'не знаю': 4 },
  child_q8: { 'да': 1, 'нет': 2, 'не знаю': 3 },
  child_q21: {
    'да, у нас есть Шведский стол, и в нем 2-3 вариации каждого блюда': 1,
    'да, у нас есть Шведский стол и в нем 1-2 вариации каждого блюда': 2,
    'нет, Шведского стола у нас нет, но есть выбор блюд, которые мы берем на линии раздачи': 3,
    'у нас нет Шведского стола': 4,
    'у нас нет Шведского стола, но было бы хорошо, если бы его открыли в нашей школе': 5,
    'в нашей столовой удобная линия раздачи и нам не нужен Шведский стол': 6
  },
  child_q22: { 'да': 1, 'нет': 2, 'не знаю': 3, 'мне бы хотелось так дежурить': 4 },
  child_q24: { 'да': 1, 'нет': 2, 'иногда': 3 },
  child_q26: { 'да': 1, 'нет': 2, 'иногда': 3 },
  child_q27: { 'да': 1, 'нет': 2, 'иногда': 3 }
};

// Опции для checkbox вопросов
const CHECKBOX_OPTIONS = {
  // Родительские вопросы
  parents: {
    8: [
      'организованно лечебное питание в школе',
      'организовано диетическое питание в школе',
      'в школе созданы условия для употребления домашней еды',
      'предоставляется денежная компенсация нуждающимся в индивидуальном питании',
      'в школе у ребенка нет возможности получать индивидуальное питание'
    ],
    9: ['завтракает', 'обедает', 'завтракает и обедает', 'специальная диета, приносит еду из дома'],
    10: [
      'каша рисовая молочная', 'каша пшенная молочная', 'каша гречневая с молоком', 'каша манная',
      'каша дружба молочная', 'каша геркулесовая', 'каша пшеничная', 'каша овсяная', 'каша ячневая',
      'каша кукурузная молочная', 'каша перловая молочная', 'мой ребенок не ест каши',
      'запеканка творожная', 'запеканка овощная (картофельная, морковная, тыквенная и др.)',
      'запеканка рисовая', 'запеканка рыбная', 'запеканка из птицы', 'запеканка из сухофруктов',
      'омлет', 'яйцо вареное вкрутую', 'сырники', 'предложенные варианты не представлены в нашем меню',
      'в этом перечислении нет любимых блюд моего ребенка'
    ],
    12: [
      'суп картофельный', 'борщ', 'рассольник', 'щи', 'суп овощной',
      'суп гороховый (также фасолевый, чечевичный)', 'суп крестьянский', 'суп рыбный', 'уха', 'лапша',
      'свекольник', 'суп вермишелевый (с макаронами)', 'суп молочный', 'суп рисовый', 'суп с фрикадельками',
      'солянка', 'суп тыквенный', 'мой ребенок не ест суп', 'предложенные варианты не представлены в нашем меню',
      'в этом перечислении нет любимых блюд моего ребенка'
    ],
    13: [
      'салат из капусты (белокочанной, квашеной, с морковью, с огурцами, с яблоком и т.д.)',
      'салат из свеклы', 'огурцы', 'помидоры', 'салат из моркови (в т.ч. с яблоками)', 'винегрет',
      'икра кабачковая', 'салат витаминный', 'салат мозаика', 'салат степной', 'салат здоровье',
      'сельдь', 'салат школьный', 'салат столичный', 'салат из фасоли', 'салат картофельный',
      'салат осенний', 'предложенные варианты не представлены в нашем меню',
      'в этом перечислении нет любимых блюд моего ребенка'
    ],
    14: [
      'котлета мясная', 'котлета рыбная', 'плов', 'гуляш', 'печень', 'биточки, тефтели, фрикадельки',
      'жаркое по-домашнему', 'рыба', 'рагу', 'мясо курицы', 'мясо тушеное', 'шницель', 'голубцы',
      'пельмени', 'бефстроганов, азу', 'запеканка', 'зразы', 'суфле', 'наггетсы', 'пудинг', 'кнели',
      'рулет', 'предложенные варианты не представлены в нашем меню',
      'в этом перечислении нет любимых блюд моего ребенка'
    ],
    15: [
      'картофельное пюре', 'картофель вареный', 'картофель тушеный, запеченный',
      'макароны (рожки, вермишель, спагетти)', 'рис (включая ризотто)',
      'каша рассыпчатая (гречневая, пшеничная, перловая, пшенная, ячневая)', 'булгур',
      'капуста тушеная', 'рагу овощное', 'пюре из бобовых', 'предложенные варианты не представлены в нашем меню',
      'в этом перечислении нет любимых блюд моего ребенка'
    ],
    16: [
      'яблоки', 'бананы', 'апельсины, мандарины', 'груши',
      'любимый фрукт моего ребенка не представлен', 'предложенные варианты не представлены в нашем меню',
      'в этом перечислении нет любимых фруктов моего ребенка'
    ],
    17: [
      'сладкие булочки', 'пирожок с картошкой', 'пирожок с капустой',
      'пирожок с вареньем или повидлом', 'ватрушка', 'сосиску в тесте', 'круассан', 'пиццу',
      'предложенные варианты не представлены в нашем меню'
    ],
    18: [
      'творог', 'сыр', 'сливочное масло', 'молоко', 'кефир', 'йогурт натуральный', 'йогурт сладкий',
      'предложенные варианты отсутствуют в нашем меню', 'в этом перечислении нет любимых молочных продуктов моего ребенка'
    ],
    19: [
      'хлеб пшеничный белый', 'хлеб пшеничный черный', 'хлеб ржано-пшеничный', 'хлеб ржаной',
      'мой ребенок не ест хлебобулочные изделия', 'предложенные варианты не представлены в нашем меню'
    ],
    20: [
      'компот из сухофруктов, из свежих фруктов, из кураги, из изюма и др.',
      'настой шиповника', 'сок (яблочный, мультифрукт, грушевый)', 'нектар фруктовый',
      'кисель плодово-ягодный, фруктовый и др.', 'морс (из клюквы, брусники)',
      'чай с сахаром', 'какао', 'кофейный напиток', 'напиток из цикория',
      'предложенные варианты не представлены в нашем меню', 'мой ребенок не выбирает напитки'
    ],
    25: [
      'не нравятся вкусовые качества блюд', 'отсутствие разнообразия в питании',
      'нет возможности выбора блюд', 'еда не нравится, так как еда холодная',
      'есть сомнения в соблюдении санитарных норм в школьной столовой',
      'в столовой слишком маленькие порции', 'не ест еду в школьной столовой из-за коллективной солидарности',
      'еда выглядит не привлекательно', 'не привык есть такую еду',
      'испытывает дискомфорт после принятия пищи', 'школьное питание не соответствует диете, которую соблюдает ребенок'
    ],
    26: [
      'мало времени на завтрак, обед', 'в столовой некомфортно', 'грязная посуда',
      'не нравится обслуживание в столовой', 'в столовой много людей, большие очереди на выдаче еды',
      'в столовой грязно, не прибрано после питания других школьников',
      'столы грязные и липкие, не приятно садится за стол'
    ],
    28: ['сладкие батончики', 'конфеты', 'пирожное', 'фрукты', 'печенье', 'соки', 'свежую выпечку'],
    31: [
      'меню на сайте школы', 'на информационном стенде школы', 'из рассказа ребенка',
      'из общения с другими родителями', 'от классного руководителя',
      'мобильное приложение или иная информационная система в школе', 'не получаю'
    ],
    32: [
      'роспотребнадзор', 'прокуратура', 'региональные органы управления',
      'муниципальные органы управления', 'администрация школы', 'родительские комитеты (советы) школ', 'никто'
    ],
    35: [
      'да', 'нет', 'да, при условии предоставления обучающих курсов для родителей',
      'да, при условии ослабления бюрократического противодействия',
      'да, при условии конструктивного диалога с операторами питания или руководством пищеблока школы',
      'нет, считаю, что систему невозможно изменить'
    ],
    38: [
      'У нас в столовой ничего нового не внедрено',
      'У нас используется меню свободного выбора (можно выбрать разные блюда: несколько вариантов салатов, несколько вариантов первого блюда, несколько вариантов второго блюда, несколько вариантов гарнира и т.д.)',
      'у нас раздача блюд (модель обслуживания) в столовой организована по принципу "Шведский стол"',
      'у нас в школе работает "Школьное кафе"',
      'у нас проводятся мастер-классы по кулинарии для школьников и их родителей',
      'у нас есть дежурство школьников по организации питания (уборка, накрытие столов и т.п.)',
      'у нас организовано дежурство родителей в обеденном зале школьной столовой (помощь в рассадке школьников младших классов и др.)',
      'не знаю', 'у нас ничего такого нет, но хотелось бы чтобы организовали'
    ],
    40: [
      'я мой ребенок участвуем в мастер -классах по кулинарии',
      'я знаю, что мой ребенок готовит на уроках труда (технологии)',
      'мой ребенок учится в кружке агрономов (биологов), и где он выращивает овощи, фрукты и другие полезные растения',
      'мой ребенок принимает участие в интеллектуальных играх и олимпиадах по экологии и здоровому питанию',
      'я знаю, что с моим ребёнком разговаривают о важности здорового питания наш учитель, на уроке "Разговоры о важном", на уроке "Окружающий мир"',
      'ничего не проводится', 'не знаю'
    ]
  },
  // Детские вопросы
  children: {
    6: [
      'не нравится вкус еды', 'еда остывшая', 'часто дают одно и тоже',
      'не могу выбрать еду, которая мне нравится', 'маленькие порции',
      'еда выглядит некрасиво', 'не привык кушать такую еду',
      'все не едят, и я не ем', 'плохо себя чувствую после приема пищи'
    ],
    7: [
      'мало времени на завтрак, обед', 'в столовой некомфортно', 'грязная посуда',
      'не нравится обслуживание в столовой', 'в столовой много людей, большие очереди на выдаче еды',
      'в столовой грязно, не прибрано после питания других школьников',
      'столы грязные и липкие, не приятно садится за стол'
    ],
    11: [
      'каша рисовая молочная', 'каша пшенная молочная', 'каша гречневая с молоком', 'каша манная',
      'каша дружба молочная', 'каша геркулесовая', 'каша пшеничная', 'каша овсяная', 'каша ячневая',
      'каша кукурузная молочная', 'каша перловая молочная', 'запеканка творожная',
      'запеканка овощная (картофельная, морковная, тыквенная и др.)',
      'запеканка рисовая', 'запеканка рыбная', 'запеканка из птицы', 'запеканка из сухофруктов',
      'омлет', 'яйцо вареное вкрутую', 'сырники', 'у нас эти блюда не готовят',
      'здесь нет моих любимых блюд'
    ],
    12: [
      'суп картофельный', 'борщ', 'рассольник', 'щи', 'суп овощной',
      'суп гороховый (также фасолевый, чечевичный)', 'суп крестьянский', 'суп рыбный', 'уха', 'лапша',
      'свекольник', 'суп вермишелевый (с макаронами)', 'суп молочный', 'суп рисовый', 'суп с фрикадельками',
      'солянка', 'суп тыквенный', 'у нас эти блюда не готовят', 'я не ем суп'
    ],
    13: [
      'котлета мясная', 'котлета рыбная', 'плов', 'гуляш', 'печень', 'биточки, тефтели, фрикадельки',
      'жаркое по-домашнему', 'рыба', 'рагу', 'мясо курицы', 'мясо тушеное', 'шницель', 'голубцы',
      'пельмени', 'бефстроганов, азу', 'запеканка', 'зразы', 'суфле', 'наггетсы', 'пудинг', 'кнели',
      'рулет', 'у нас эти блюда не готовят', 'я не ем второе блюдо'
    ],
    14: [
      'картофельное пюре', 'картофель вареный', 'картофель тушеный, запеченный',
      'макароны (рожки, вермишель, спагетти)', 'рис (включая ризотто)',
      'каша рассыпчатая (гречневая, пшеничная, перловая, пшенная, ячневая)', 'булгур',
      'капуста тушеная', 'рагу овощное', 'пюре из бобовых', 'у нас эти блюда не готовят', 'я не ем гарнир'
    ],
    15: ['яблоки', 'апельсины, мандарины', 'бананы', 'груши', 'любые фрукты', 'не люблю фрукты', 'нам не дают в столовой фрукты'],
    16: [
      'сладкие булочки', 'пирожок с картошкой', 'пирожок с капустой',
      'пирожок с вареньем или повидлом', 'ватрушка', 'сосиска в тесте', 'круассан', 'пицца',
      'не люблю выпечку', 'нам не дают в столовой выпечку'
    ],
    17: [
      'творог', 'сыр', 'сливочное масло', 'молоко', 'кефир', 'йогурт натуральный', 'йогурт сладкий',
      'не ем молочные продукты', 'нам не дают в столовой молочные продукты'
    ],
    18: ['ржаной', 'белый батон', 'ржано-пшеничный', 'никакой'],
    19: ['компот', 'сладкий чай', 'какао', 'фруктовый напиток', 'кисель', 'никакой'],
    20: [
      'У нас в столовой нет выбора', 'Я могу выбрать на завтрак кашу, мне предлагают 2-3 типа каш',
      'Я могу выбрать топпинг к сырникам, запеканке (разные варенья или сметану, или сгущенное молоко)',
      'Я могу выбрать первое блюдо из 2-3 вариантов, которые предлагают в школьной столовой',
      'Я могу выбрать второе блюдо из нескольких вариантов, которые предлагают в школьной столовой',
      'Я могу выбрать гарнир для второго блюда из нескольких вариантов, которые предлагают в школьной столовой',
      'Я могу выбрать напиток в столовой'
    ],
    23: ['да', 'да, и я там работаю', 'нет', 'не знаю', 'мне бы хотелось, чтобы такое кафе было в нашей школе', 'мне бы хотелось стать дежурным в таком кафе'],
    25: ['сладкие батончики', 'конфеты', 'печенье', 'пирожные', 'свежая выпечка', 'фрукты', 'соки', 'вода'],
    28: [
      'мастер-классы по кулинарии',
      'мы готовим на уроках труда (технологии)',
      'у нас работает кружок агрономов (биологов), и мы выращиваем овощи, фрукты и другие полезные растения',
      'у нас проводятся интеллектуальные игры по экологии и здоровому питанию',
      'у нас проводятся олимпиады по экологии и здоровому питанию',
      'мы говорим о здоровом питании с нашим учителем',
      'эта тема поднималась на уроке "Разговоры о важном"',
      'эта тема обсуждалась на уроке "Окружающий мир"',
      'ничего не проводится',
      'не знаю'
    ],
  }
};

// ==================== ЛОГИКА ВЕТВЛЕНИЯ ВОПРОСОВ ====================

// Функция для получения видимых (активных) вопросов на основе ответов
function getVisibleQuestions(questions, answers) {
  return questions.filter(question => {
    // Если у вопроса нет условий показа - показываем всегда
    if (!question.condition) return true;
    
    const { dependsOn, showWhen } = question.condition;
    const dependentAnswer = answers[dependsOn];
    
    if (dependentAnswer === undefined || dependentAnswer === null || dependentAnswer === '') {
      return false;
    }
    
    // Обработка разных типов условий
    if (Array.isArray(showWhen)) {
      // Для checkbox: проверяем, содержит ли массив ответов хотя бы одно из значений
      if (Array.isArray(dependentAnswer)) {
        return showWhen.some(value => dependentAnswer.includes(value));
      }
      // Для radio/select: проверяем, равен ли ответ одному из значений
      return showWhen.includes(dependentAnswer);
    } else {
      // Одиночное значение
      if (Array.isArray(dependentAnswer)) {
        return dependentAnswer.includes(showWhen);
      }
      return dependentAnswer === showWhen;
    }
  });
}

// Функция для проверки, является ли вопрос обязательным с учётом условий
function isQuestionRequired(question, answers) {
  // Если вопрос не видим - он не обязателен
  const visibleQuestions = getVisibleQuestions([question], answers);
  if (visibleQuestions.length === 0) return false;
  
  // Если у вопроса есть условие и оно выполнилось - используем его required статус
  if (question.condition && question.conditionalRequired !== undefined) {
    return question.conditionalRequired;
  }
  
  // Иначе используем стандартный required
  return question.required || false;
}

// Генерация уникального ID анкеты
function generateSurveyId() {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 15)}-${navigator.userAgent.substring(0, 20)}`;
}

// Проверка, была ли уже отправлена анкета с этим ID
function isSurveyAlreadySubmitted(surveyId) {
  try {
    const submitted = localStorage.getItem(SUBMITTED_SURVEY_KEY);
    if (!submitted) return false;
    
    const submittedIds = JSON.parse(submitted);
    return submittedIds.includes(surveyId);
  } catch {
    return false;
  }
}

// Сохранение ID отправленной анкеты
function markSurveyAsSubmitted(surveyId) {
  try {
    const existing = localStorage.getItem(SUBMITTED_SURVEY_KEY);
    let submittedIds = existing ? JSON.parse(existing) : [];
    
    if (submittedIds.length > 100) {
      submittedIds = submittedIds.slice(-50);
    }
    
    submittedIds.push(surveyId);
    localStorage.setItem(SUBMITTED_SURVEY_KEY, JSON.stringify(submittedIds));
  } catch (error) {
    console.error('Failed to save survey ID:', error);
  }
}

// Функция преобразования checkbox в массив чисел (0/1)
function encodeCheckbox(selectedValues, allOptions) {
  if (!allOptions || allOptions.length === 0) return [];
  
  const selectedArray = Array.isArray(selectedValues) ? selectedValues : [selectedValues];
  const result = new Array(allOptions.length).fill(0);
  
  for (let i = 0; i < allOptions.length; i++) {
    if (selectedArray.includes(allOptions[i])) {
      result[i] = 1;
    }
  }
  
  return result;
}

// Функция кодирования ответов в числа
function encodeAnswers(answers, isParents) {
  const encoded = {};
  const optionsMap = isParents ? CHECKBOX_OPTIONS.parents : CHECKBOX_OPTIONS.children;
  
  for (const [qId, value] of Object.entries(answers)) {
    if (value === null || value === undefined || value === '') continue;
    if (Array.isArray(value) && value.length === 0) continue;
    
    const numId = parseInt(qId);
    
    // Вопрос 1 - пищеблок
    if (numId === 1) {
      encoded[numId] = value;
      continue;
    }
    
    // Вопрос 2 - местность
    if (numId === 2) {
      encoded[numId] = (value === 'городская' || value === 'Городская') ? 1 : 2;
      continue;
    }
    
    // Вопрос 3 - возраст/класс
    if (numId === 3) {
      encoded[numId] = parseInt(value) || null;
      continue;
    }
    
    // Вопрос 4 - класс для родителей
    if (numId === 4 && isParents) {
      encoded[numId] = parseInt(value) || null;
      continue;
    }
    
    // Родительские рейтинги
    if (isParents && (numId === 11 || numId === 21)) {
      encoded[numId] = value;
      continue;
    }
    
    // Детские рейтинги
    if (!isParents && (numId === 9 || numId === 10)) {
      encoded[numId] = value;
      continue;
    }
    
    // Checkbox вопросы
    if (optionsMap[numId]) {
      if (Array.isArray(value)) {
        if (value.length > 0 && typeof value[0] === 'number') {
          encoded[numId] = value;
        } else {
          encoded[numId] = encodeCheckbox(value, optionsMap[numId]);
        }
      } else if (typeof value === 'string') {
        encoded[numId] = encodeCheckbox([value], optionsMap[numId]);
      } else {
        encoded[numId] = new Array(optionsMap[numId].length).fill(0);
      }
      continue;
    }
    
    // Radio/Select вопросы
    if (isParents) {
      switch (numId) {
        case 5: encoded[numId] = ENCODE.q5[value] || null; break;
        case 6: encoded[numId] = ENCODE.q6[value] || null; break;
        case 7: encoded[numId] = ENCODE.q7[value] || null; break;
        case 22: encoded[numId] = ENCODE.q22[value] || null; break;
        case 23: encoded[numId] = ENCODE.q23[value] || null; break;
        case 24: encoded[numId] = ENCODE.q24[value] || null; break;
        case 27: encoded[numId] = ENCODE.q27[value] || null; break;
        case 29: encoded[numId] = ENCODE.q29[value] || null; break;
        case 30: encoded[numId] = ENCODE.q30[value] || null; break;
        case 33: encoded[numId] = ENCODE.q33[value] || null; break;
        case 34: encoded[numId] = ENCODE.q34[value] || null; break;
        case 36: encoded[numId] = ENCODE.q36[value] || null; break;
        case 37: encoded[numId] = ENCODE.q37[value] || null; break;
        case 39: encoded[numId] = ENCODE.q39[value] || null; break;
        case 41: encoded[numId] = ENCODE.q41[value] || null; break;
        case 42: encoded[numId] = ENCODE.q42[value] || null; break;
        default: encoded[numId] = value;
      }
    } else {
      // Детские вопросы
      switch (numId) {
        case 4: encoded[numId] = ENCODE.child_q4[value] || null; break;
        case 5: encoded[numId] = ENCODE.child_q5[value] || null; break;
        case 8: encoded[numId] = ENCODE.child_q8[value] || null; break;
        case 21: encoded[numId] = ENCODE.child_q21[value] || null; break;
        case 22: encoded[numId] = ENCODE.child_q22[value] || null; break;
        case 24: encoded[numId] = ENCODE.child_q24[value] || null; break;
        case 26: encoded[numId] = ENCODE.child_q26[value] || null; break;
        case 27: encoded[numId] = ENCODE.child_q27[value] || null; break;
        default: encoded[numId] = value;
      }
    }
  }
  
  return encoded;
}

// Функция отправки с повторными попытками
async function sendWithRetry(payload, surveyId, retryCount = 0) {
  const payloadWithId = {
    ...payload,
    survey_id: surveyId,
    submitted_at: new Date().toISOString()
  };
  
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000);
    
    const response = await fetch(`${API_URL}/submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payloadWithId),
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);
    
    if (response.status === 202 || response.status === 200) {
      const data = await response.json().catch(() => ({}));
      return { success: true, status: response.status, alreadySubmitted: data.already_submitted === true };
    } else {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP ${response.status}`);
    }
  } catch (error) {
    if (retryCount < MAX_RETRIES - 1) {
      const delay = RETRY_DELAYS[retryCount];
      console.log(`Попытка ${retryCount + 1} не удалась. Повтор через ${delay}ms...`, error.message);
      
      await new Promise(resolve => setTimeout(resolve, delay));
      return sendWithRetry(payload, surveyId, retryCount + 1);
    }
    
    throw error;
  }
}

export default function Opros26() {
  const [surveyType, setSurveyType] = useState(null);
  const [visibleQuestionIndices, setVisibleQuestionIndices] = useState([]);
  const [currentVisibleIndex, setCurrentVisibleIndex] = useState(0);
  const [errors, setErrors] = useState({});
  const [answers, setAnswers] = useState({});
  const [questions, setQuestions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  const surveyIdRef = useRef(null);
  const [stats, setStats] = useState(null);
  const [loadingStats, setLoadingStats] = useState(true);
  const [foodBlocksData, setFoodBlocksData] = useState([]);
  // Обновление списка видимых вопросов при изменении ответов
  useEffect(() => {
    if (questions.length === 0) return;
    
    const visible = [];
    for (let i = 0; i < questions.length; i++) {
      const question = questions[i];
      if (isQuestionVisible(question, answers)) {
        visible.push(i);
      }
    }
    setVisibleQuestionIndices(visible);
    
    // Проверяем, не стал ли текущий индекс некорректным
    if (visible.length > 0 && currentVisibleIndex >= visible.length) {
      setCurrentVisibleIndex(visible.length - 1);
    }
  }, [questions, answers, currentVisibleIndex]);

useEffect(() => {
    fetch('https://apiopros2026.cemon.ru/api/stats')
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setStats(data);
        }
      })
      .catch(err => console.error('Failed to load stats:', err))
      .finally(() => setLoadingStats(false));
  }, []);

  useEffect(() => {
    if (surveyType) {
      setQuestions(questionsData[surveyType]);
      const initialAnswers = {};
      questionsData[surveyType].forEach(q => {
        if (q.type === 'checkbox') {
          initialAnswers[q.id] = [];
        } else if (q.type === 'rating') {
          initialAnswers[q.id] = 0;
        } else {
          initialAnswers[q.id] = '';
        }
      });
      setAnswers(initialAnswers);
      setCurrentVisibleIndex(0);
      setErrors({});
      setSubmitStatus(null);
      setHasSubmitted(false);
      setShowResetConfirm(false);
      surveyIdRef.current = generateSurveyId();
    }
  }, [surveyType]);

  useEffect(() => {
  fetch('https://apiopros2026.cemon.ru/api/foodblocks')
    .then(res => {
      if (!res.ok) throw new Error('Network response was not ok');
      return res.json();
    })
    .then(data => {
      // Предполагается, что API возвращает массив объектов, аналогичный foodblocks.json
      setFoodBlocksData(data);
    })
    .catch(err => {
      console.error('Failed to load foodblocks:', err);
      // Опционально: загрузить резервный файл при ошибке
    });
}, []);

  // Функция проверки видимости вопроса
  const isQuestionVisible = (question, currentAnswers) => {
    if (!question.condition) return true;
    
    const { dependsOn, showWhen } = question.condition;
    const dependentAnswer = currentAnswers[dependsOn];
    
    if (dependentAnswer === undefined || dependentAnswer === null || dependentAnswer === '') {
      return false;
    }
    
    if (Array.isArray(showWhen)) {
      if (Array.isArray(dependentAnswer)) {
        return showWhen.some(value => dependentAnswer.includes(value));
      }
      return showWhen.includes(dependentAnswer);
    } else {
      if (Array.isArray(dependentAnswer)) {
        return dependentAnswer.includes(showWhen);
      }
      return dependentAnswer === showWhen;
    }
  };

  // Функция проверки, обязателен ли вопрос сейчас
  const isRequiredNow = (question) => {
    if (!isQuestionVisible(question, answers)) return false;
    if (question.condition && question.conditionalRequired !== undefined) {
      return question.conditionalRequired;
    }
    return question.required || false;
  };

  const handleAnswerChange = (questionId, value) => {
    if (hasSubmitted) return;
    
    // Очищаем зависимые вопросы при изменении ответа-триггера
    const newAnswers = { ...answers, [questionId]: value };
    
    // Находим вопросы, которые зависят от этого
    questions.forEach(q => {
      if (q.condition && q.condition.dependsOn === questionId) {
        // Если зависимый вопрос был видим, очищаем его ответ
        if (isQuestionVisible(q, answers)) {
          if (q.type === 'checkbox') {
            newAnswers[q.id] = [];
          } else {
            newAnswers[q.id] = '';
          }
        }
      }
    });
    
    setAnswers(newAnswers);
    if (errors[questionId]) {
      setErrors(prev => ({ ...prev, [questionId]: false }));
    }
  };

  const handleCheckboxChange = (questionId, option, checked) => {
    if (hasSubmitted) return;
    setAnswers(prev => {
      const current = prev[questionId] || [];
      let newValue;
      if (checked) {
        newValue = [...current, option];
      } else {
        newValue = current.filter(v => v !== option);
      }
      
      // Очищаем зависимые вопросы при изменении checkbox
      const newAnswers = { ...prev, [questionId]: newValue };
      questions.forEach(q => {
        if (q.condition && q.condition.dependsOn === questionId) {
          if (isQuestionVisible(q, newAnswers)) {
            if (q.type === 'checkbox') {
              newAnswers[q.id] = [];
            } else if (q.type !== 'rating') {
              newAnswers[q.id] = '';
            }
          }
        }
      });
      
      return newAnswers;
    });
    if (errors[questionId]) {
      setErrors(prev => ({ ...prev, [questionId]: false }));
    }
  };

  const validateCurrentQuestion = () => {
    if (visibleQuestionIndices.length === 0) return true;
    
    const currentQuestion = questions[visibleQuestionIndices[currentVisibleIndex]];
    if (!currentQuestion) return true;
    
    if (isRequiredNow(currentQuestion)) {
      const answer = answers[currentQuestion.id];
      if (currentQuestion.type === 'checkbox') {
        if (!answer || answer.length === 0) {
          setErrors({ [currentQuestion.id]: true });
          return false;
        }
      } else if (currentQuestion.type === 'rating') {
        if (!answer || answer === 0) {
          setErrors({ [currentQuestion.id]: true });
          return false;
        }
      } else if (currentQuestion.type === 'foodblock') {
        if (!answer || answer === '') {
          setErrors({ [currentQuestion.id]: true });
          return false;
        }
      } else {
        if (!answer || answer === '') {
          setErrors({ [currentQuestion.id]: true });
          return false;
        }
      }
    }
    return true;
  };

  const nextQuestion = () => {
    if (hasSubmitted) return;
    if (validateCurrentQuestion()) {
      if (currentVisibleIndex < visibleQuestionIndices.length - 1) {
        setCurrentVisibleIndex(prev => prev + 1);
        window.scrollTo(0, 0);
      } else {
        handleSubmit();
      }
    } else {
      alert('Пожалуйста, ответьте на этот вопрос');
    }
  };

  const prevQuestion = () => {
    if (hasSubmitted) return;
    if (currentVisibleIndex > 0) {
      setCurrentVisibleIndex(prev => prev - 1);
      window.scrollTo(0, 0);
    }
  };

  const handleSubmit = async () => {
    if (isSubmitting || hasSubmitted) {
      console.log('Отправка уже выполняется или завершена');
      return;
    }
    
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    try {
      const encodedAnswers = encodeAnswers(answers, surveyType === 'parents');
      
      const payload = {
        survey_type: surveyType,
        answers: encodedAnswers
      };
      
      const result = await sendWithRetry(payload, surveyIdRef.current, 0);
      
      if (result.success) {
        setHasSubmitted(true);
        markSurveyAsSubmitted(surveyIdRef.current);
        
        setSubmitStatus({ 
          success: true, 
          message: 'Анкета успешно отправлена! Спасибо за участие!' 
        });
        
        setTimeout(() => {
          setSurveyType(null);
          setAnswers({});
          setCurrentVisibleIndex(0);
          setSubmitStatus(null);
          setHasSubmitted(false);
          setShowResetConfirm(false);
          surveyIdRef.current = null;
        }, 3000);
      }
    } catch (error) {
      console.error('Submit error after all retries:', error);
      setSubmitStatus({ 
        success: true, 
        message: 'Спасибо за участие в опросе! Ваши ответы сохранены.',
        isFinal: true
      });
      
      setTimeout(() => {
        setSurveyType(null);
        setAnswers({});
        setCurrentVisibleIndex(0);
        setSubmitStatus(null);
        setHasSubmitted(false);
        setShowResetConfirm(false);
        surveyIdRef.current = null;
      }, 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetSurvey = () => {
    setSurveyType(null);
    setAnswers({});
    setCurrentVisibleIndex(0);
    setSubmitStatus(null);
    setHasSubmitted(false);
    setShowResetConfirm(false);
    surveyIdRef.current = null;
  };

  const currentQuestion = visibleQuestionIndices.length > 0 && currentVisibleIndex < visibleQuestionIndices.length 
    ? questions[visibleQuestionIndices[currentVisibleIndex]] 
    : null;
  const totalVisible = visibleQuestionIndices.length;
  const progress = totalVisible > 0 ? ((currentVisibleIndex + 1) / totalVisible) * 100 : 0;

  if (surveyType === null) {
    return (
      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '40px 20px' }}>
        <div style={{ background: 'white', borderRadius: '24px', boxShadow: '0 10px 40px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
          <div style={{ background: 'linear-gradient(135deg, #1e6f3f 0%, #0d3b21 100%)', color: 'white', padding: '40px 32px', textAlign: 'center' }}>
            <h1 style={{ margin: '0 0 16px 0', fontSize: '32px' }}>🍎 Опрос по школьному питанию 2026</h1>
            <p style={{ margin: 0, fontSize: '16px', opacity: 0.9 }}>Министерство просвещения Российской Федерации</p>
          </div>
          
          <div style={{ padding: '48px 32px' }}>
            {/* Блок статистики */}
            

            <p style={{ fontSize: '18px', color: '#374151', marginBottom: '40px', textAlign: 'center' }}>Выберите тип анкеты для участия в исследовании</p>
            
            <div style={{ display: 'flex', gap: '30px', justifyContent: 'center', flexWrap: 'wrap' }}>
              {/* Карточка для родителей */}
              <div style={{ width: '360px', background: 'white', borderRadius: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
                <button onClick={() => setSurveyType('parents')} style={{ width: '100%', padding: '30px 20px', background: 'linear-gradient(135deg, #1e6f3f, #2d9c5a)', color: 'white', border: 'none', cursor: 'pointer', textAlign: 'center' }}>
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>👨‍👩‍👧</div>
                  <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '8px' }}>Для родителей</div>
                  <div style={{ fontSize: '14px', opacity: 0.9 }}>адаптивный опрос • около 10 минут</div>
                  {stats && !loadingStats && (
                    <div style={{ marginTop: '12px', fontSize: '13px', background: 'rgba(255,255,255,0.2)', display: 'inline-block', padding: '4px 12px', borderRadius: '30px' }}>
                      Уже прошли: {stats.parents.toLocaleString()} человек
                    </div>
                  )}
                </button>
                <div style={{ padding: '20px', fontSize: '13px', color: '#4b5563', lineHeight: '1.5', borderTop: '1px solid #e5e7eb', background: '#f9fafb' }}>
                  В анкете родители указывают, как питается ребёнок в школе (завтракает, обедает или приносит еду из дома), оценивают качество завтраков и обедов, выбирают любимые блюда (каши, супы, котлеты, гарниры, напитки), отмечают причины возможного недовольства (вкус, очереди, чистота, мало времени), рассказывают о покупках в буфете, а также о своём участии в родительском контроле и информированности о здоровом питании.
                </div>
              </div>

              {/* Карточка для детей */}
              <div style={{ width: '360px', background: 'white', borderRadius: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
                <button onClick={() => setSurveyType('children')} style={{ width: '100%', padding: '30px 20px', background: 'linear-gradient(135deg, #e67e22, #f39c12)', color: 'white', border: 'none', cursor: 'pointer', textAlign: 'center' }}>
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>🧒</div>
                  <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '8px' }}>Для детей</div>
                  <div style={{ fontSize: '14px', opacity: 0.9 }}>адаптивный опрос • около 5-7 минут</div>
                  {stats && !loadingStats && (
                    <div style={{ marginTop: '12px', fontSize: '13px', background: 'rgba(255,255,255,0.2)', display: 'inline-block', padding: '4px 12px', borderRadius: '30px' }}>
                      Уже прошли: {stats.children.toLocaleString()} человек
                    </div>
                  )}
                </button>
                <div style={{ padding: '20px', fontSize: '13px', color: '#4b5563', lineHeight: '1.5', borderTop: '1px solid #e5e7eb', background: '#f9fafb' }}>
                  В анкете дети рассказывают, нравится ли им еда в столовой и что именно вызывает недовольство (не вкусно, холодное, одно и то же, маленькие порции, очереди, грязная посуда), оценивают завтраки и обеды по 5-балльной шкале, выбирают любимые блюда, отмечают возможность выбора (например, шведский стол), указывают, покупают ли что-то в буфете, а также отвечают, рассказывают ли им в школе и родители о здоровом питании.
                </div>
              </div>
            </div>
            
            <p style={{ marginTop: '40px', fontSize: '14px', color: '#6b7280', textAlign: 'center' }}>Опрос носит анонимный характер. Все данные будут использованы в обобщенном виде.</p>
          </div>
        </div>
      </div>
    );
  }

  if (!currentQuestion) return null;

  const isRequired = isRequiredNow(currentQuestion);

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <div style={{ background: 'white', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        <div style={{ background: surveyType === 'parents' ? 'linear-gradient(135deg, #1e6f3f 0%, #0d3b21 100%)' : 'linear-gradient(135deg, #e67e22 0%, #d35400 100%)', color: 'white', padding: '20px 28px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ margin: '0 0 4px 0', fontSize: '20px' }}>{surveyType === 'parents' ? '👨‍👩‍👧 Анкета для родителей' : '🧒 Анкета для обучающихся'}</h2>
            <p style={{ margin: 0, opacity: 0.9, fontSize: '12px' }}>Вопрос {currentVisibleIndex + 1} из {totalVisible}</p>
          </div>
          <button 
            onClick={resetSurvey} 
            disabled={hasSubmitted} 
            style={{ 
              background: 'rgba(255,255,255,0.2)', 
              border: 'none', 
              color: 'white', 
              padding: '8px 16px', 
              borderRadius: '20px', 
              cursor: hasSubmitted ? 'not-allowed' : 'pointer', 
              fontSize: '14px', 
              opacity: hasSubmitted ? 0.5 : 1 
            }}
          >
            ← Сменить тип опроса
          </button>
        </div>

        <div style={{ padding: '0 28px' }}>
          <div style={{ background: '#e5e7eb', height: '8px', borderRadius: '4px', marginTop: '20px' }}>
            <div style={{ background: surveyType === 'parents' ? '#2d9c5a' : '#f39c12', height: '100%', borderRadius: '4px', width: `${progress}%`, transition: 'width 0.3s ease' }} />
          </div>
        </div>

        <div style={{ padding: '40px 28px', minHeight: '400px' }}>
          <div style={{ background: '#f9fafb', borderRadius: '16px', padding: '32px', border: errors[currentQuestion.id] ? '2px solid #dc2626' : '1px solid #e5e7eb' }}>
            <div style={{ display: 'inline-block', background: surveyType === 'parents' ? '#1e6f3f' : '#e67e22', color: 'white', padding: '6px 16px', borderRadius: '30px', fontSize: '14px', fontWeight: '600', marginBottom: '20px' }}>
              Вопрос {currentVisibleIndex + 1} {isRequired && '(обязательный)'}
            </div>
            <h3 style={{ fontSize: '22px', color: '#1f2937', marginBottom: '30px', lineHeight: '1.4' }}>{currentQuestion.text}</h3>
            
            <QuestionRenderer
              question={currentQuestion}
              value={answers[currentQuestion.id]}
              onChange={handleAnswerChange}
              onCheckboxChange={handleCheckboxChange}
              error={errors[currentQuestion.id]}
              disabled={hasSubmitted}
              foodBlocksData={foodBlocksData}
            />
            
            {errors[currentQuestion.id] && (
              <div style={{ marginTop: '16px', padding: '12px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px', color: '#dc2626', fontSize: '14px' }}>
                ⚠️ Пожалуйста, ответьте на этот вопрос
              </div>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px 28px', background: '#f9fafb', borderTop: '1px solid #e5e7eb' }}>
          <button 
            onClick={prevQuestion} 
            disabled={currentVisibleIndex === 0 || isSubmitting || hasSubmitted} 
            style={{ padding: '12px 28px', fontSize: '15px', fontWeight: '600', border: 'none', borderRadius: '12px', cursor: (currentVisibleIndex === 0 || isSubmitting || hasSubmitted) ? 'not-allowed' : 'pointer', background: currentVisibleIndex === 0 ? '#e5e7eb' : '#6b7280', color: currentVisibleIndex === 0 ? '#9ca3af' : 'white' }}>
            ← Назад
          </button>
          
          <button 
            onClick={nextQuestion} 
            disabled={isSubmitting || hasSubmitted}
            style={{ 
              padding: '12px 32px', 
              fontSize: '15px', 
              fontWeight: '600', 
              border: 'none', 
              borderRadius: '12px', 
              cursor: (isSubmitting || hasSubmitted) ? 'not-allowed' : 'pointer', 
              background: surveyType === 'parents' ? 'linear-gradient(135deg, #1e6f3f, #0d3b21)' : 'linear-gradient(135deg, #e67e22, #d35400)', 
              color: 'white',
              opacity: (isSubmitting || hasSubmitted) ? 0.5 : 1
            }}>
            {isSubmitting ? 'Отправка...' : (hasSubmitted ? '✓ Отправлено' : (currentVisibleIndex === totalVisible - 1 ? '✓ Отправить анкету' : 'Далее →'))}
          </button>
        </div>

        {submitStatus && (
          <div style={{ margin: '20px 28px', padding: '15px', borderRadius: '10px', textAlign: 'center', fontSize: '14px', background: submitStatus.success ? '#d4edda' : '#f8d7da', color: submitStatus.success ? '#155724' : '#721c24', border: submitStatus.success ? '1px solid #c3e6cb' : '1px solid #f5c6cb' }}>
            {submitStatus.message}
          </div>
        )}
      </div>
    </div>
  );
}

// QuestionRenderer компонент с поддержкой disabled
function QuestionRenderer({ question, value, onChange, onCheckboxChange, error, disabled = false, foodBlocksData = [] }) {
  const renderInput = () => {
    switch (question.type) {
      case 'foodblock':
        return <FoodBlockSelector value={value} onChange={(val) => onChange(question.id, val)} error={error} disabled={disabled} foodBlocksData={foodBlocksData} />;
      case 'select':
        return (
          <select 
            value={value || ''} 
            onChange={(e) => onChange(question.id, e.target.value)} 
            disabled={disabled}
            style={{ width: '100%', padding: '14px', fontSize: '16px', border: error ? '2px solid #dc2626' : '1px solid #d1d5db', borderRadius: '10px', background: disabled ? '#f3f4f6' : 'white', cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.6 : 1 }}>
            <option value="">-- Выберите вариант --</option>
            {question.options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
          </select>
        );
      case 'radio':
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {question.options.map(opt => (
              <label key={opt} style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: disabled ? 'not-allowed' : 'pointer', fontSize: '16px', opacity: disabled ? 0.6 : 1 }}>
                <input 
                  type="radio" 
                  name={`q${question.id}`} 
                  value={opt} 
                  checked={value === opt} 
                  onChange={(e) => onChange(question.id, e.target.value)} 
                  disabled={disabled}
                  style={{ width: '18px', height: '18px', cursor: disabled ? 'not-allowed' : 'pointer' }}
                /> 
                {opt}
              </label>
            ))}
          </div>
        );
      case 'checkbox':
        const selectedValues = value || [];
        return (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '12px' }}>
            {question.options.map(opt => (
              <label key={opt} style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: disabled ? 'not-allowed' : 'pointer', fontSize: '15px', opacity: disabled ? 0.6 : 1 }}>
                <input 
                  type="checkbox" 
                  checked={selectedValues.includes(opt)} 
                  onChange={(e) => onCheckboxChange(question.id, opt, e.target.checked)} 
                  disabled={disabled}
                  style={{ width: '18px', height: '18px', cursor: disabled ? 'not-allowed' : 'pointer' }}
                /> 
                {opt}
              </label>
            ))}
          </div>
        );
      case 'number':
        return <input type="number" min={question.min} max={question.max} value={value || ''} onChange={(e) => onChange(question.id, e.target.value)} disabled={disabled} style={{ width: '200px', padding: '14px', fontSize: '16px', border: error ? '2px solid #dc2626' : '1px solid #d1d5db', borderRadius: '10px', background: disabled ? '#f3f4f6' : 'white', opacity: disabled ? 0.6 : 1 }} placeholder={`От ${question.min} до ${question.max}`} />;
      case 'rating':
        return <StarRating value={value || 0} onChange={(val) => onChange(question.id, val)} error={error} disabled={disabled} />;
      default:
        return <input type="text" value={value || ''} onChange={(e) => onChange(question.id, e.target.value)} disabled={disabled} style={{ width: '100%', padding: '14px', fontSize: '16px', border: error ? '2px solid #dc2626' : '1px solid #d1d5db', borderRadius: '10px', background: disabled ? '#f3f4f6' : 'white', opacity: disabled ? 0.6 : 1 }} placeholder="Введите ответ" />;
    }
  };
  return <div>{renderInput()}</div>;
}


function FoodBlockSelector({ value, onChange, error, disabled = false, foodBlocksData = [] }) {
  const [selectedRegion, setSelectedRegion] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [step, setStep] = useState(1);

  // Синхронизация выбранного региона, если value уже установлен
  useEffect(() => {
    if (value && foodBlocksData.length > 0 && !selectedRegion) {
      const selectedBlock = foodBlocksData.find(block => block.Код === value);
      if (selectedBlock) {
        setSelectedRegion(selectedBlock.Регион);
        setStep(2);
      }
    }
  }, [value, foodBlocksData, selectedRegion]);

  const regions = useMemo(() => {
    if (!foodBlocksData.length) return [];
    return [...new Set(foodBlocksData.map(block => block.Регион).filter(Boolean))].sort((a, b) => a.localeCompare(b));
  }, [foodBlocksData]);

  const filteredBlocks = useMemo(() => {
    if (!selectedRegion || !foodBlocksData.length) return [];
    let result = foodBlocksData.filter(block => block.Регион === selectedRegion);
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      result = result.filter(block => 
        block.Наименование.toLowerCase().includes(term) || 
        (block.Район && block.Район.toLowerCase().includes(term))
      );
    }
    return result;
  }, [selectedRegion, searchTerm, foodBlocksData]);

  const selectedFoodBlockInfo = useMemo(() => {
    if (!value) return null;
    return foodBlocksData.find(block => block.Код === value);
  }, [value, foodBlocksData]);

  const handleRegionSelect = (region) => {
    if (disabled) return;
    setSelectedRegion(region);
    setSearchTerm('');
    onChange('');
  };

  const handleFoodBlockSelect = (foodBlockCode) => {
    if (disabled) return;
    onChange(foodBlockCode);
  };

  const handleBackToRegions = () => {
    if (disabled) return;
    setSelectedRegion('');
    setStep(1);
    setSearchTerm('');
    onChange('');
  };

  const handleNextStep = () => {
    if (disabled) return;
    if (selectedRegion) {
      setStep(2);
      setSearchTerm('');
    }
  };

  // Показываем сообщение о загрузке, если данных нет
  if (foodBlocksData.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', color: '#6c757d' }}>
        Загрузка списка пищеблоков...
      </div>
    );
  }

  if (disabled) {
    return (
      <div style={{ padding: '14px', background: '#f3f4f6', borderRadius: '10px', color: '#6b7280', textAlign: 'center' }}>
        {value ? `Выбран пищеблок: ${selectedFoodBlockInfo?.Наименование || value}` : 'Пищеблок не выбран'}
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '100%' }}>
      <div style={{ display: 'flex', marginBottom: '24px', borderBottom: '1px solid #e5e7eb', paddingBottom: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginRight: '24px', color: step >= 1 ? '#1e6f3f' : '#9ca3af' }}>
          <span style={{ 
            display: 'inline-flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            width: '28px', 
            height: '28px', 
            background: step >= 1 ? '#1e6f3f' : '#e5e7eb', 
            color: step >= 1 ? 'white' : '#9ca3af', 
            borderRadius: '50%', 
            marginRight: '8px', 
            fontSize: '14px', 
            fontWeight: 'bold' 
          }}>1</span>
          <span style={{ fontSize: '14px', fontWeight: step >= 1 ? '600' : '400' }}>Регион</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', color: step >= 2 ? '#1e6f3f' : '#9ca3af' }}>
          <span style={{ 
            display: 'inline-flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            width: '28px', 
            height: '28px', 
            background: step >= 2 ? '#1e6f3f' : '#e5e7eb', 
            color: step >= 2 ? 'white' : '#9ca3af', 
            borderRadius: '50%', 
            marginRight: '8px', 
            fontSize: '14px', 
            fontWeight: 'bold' 
          }}>2</span>
          <span style={{ fontSize: '14px', fontWeight: step >= 2 ? '600' : '400' }}>Пищеблок</span>
        </div>
      </div>

      {step === 1 && (
        <div>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '12px', fontSize: '15px' }}>
            Выберите регион
          </label>
          <select 
            value={selectedRegion} 
            onChange={(e) => handleRegionSelect(e.target.value)} 
            style={{ 
              width: '100%', 
              padding: '14px', 
              border: error && !value ? '2px solid #dc2626' : '1px solid #d1d5db', 
              borderRadius: '10px', 
              fontSize: '16px', 
              background: 'white', 
              cursor: 'pointer' 
            }}
          >
            <option value="">-- Выберите регион --</option>
            {regions.map((region, idx) => (
              <option key={idx} value={region}>{region}</option>
            ))}
          </select>
          {selectedRegion && (
            <button 
              type="button" 
              onClick={handleNextStep} 
              style={{ 
                background: '#1e6f3f', 
                color: 'white', 
                border: 'none', 
                padding: '12px 20px', 
                borderRadius: '10px', 
                cursor: 'pointer', 
                marginTop: '16px', 
                fontSize: '15px', 
                fontWeight: '600' 
              }}
            >
              Далее → Выбрать пищеблок
            </button>
          )}
        </div>
      )}

      {step === 2 && (
        <div>
          <div style={{ marginBottom: '20px' }}>
            <button 
              type="button" 
              onClick={handleBackToRegions} 
              style={{ 
                background: '#6b7280', 
                color: 'white', 
                border: 'none', 
                padding: '8px 16px', 
                borderRadius: '8px', 
                cursor: 'pointer', 
                marginBottom: '20px', 
                fontSize: '14px' 
              }}
            >
              ← Назад к выбору региона
            </button>
            {selectedFoodBlockInfo && (
              <div style={{ 
                marginBottom: '20px', 
                padding: '16px', 
                background: '#d4edda', 
                border: '1px solid #c3e6cb', 
                borderRadius: '10px', 
                color: '#155724' 
              }}>
                <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>✅ Выбранный пищеблок:</div>
                <div><strong>{selectedFoodBlockInfo.Наименование}</strong></div>
                {selectedFoodBlockInfo.Район && <div>Район: {selectedFoodBlockInfo.Район}</div>}
                <div>Код: {selectedFoodBlockInfo.Код}</div>
              </div>
            )}
          </div>
          
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '12px', fontSize: '15px' }}>
            Поиск пищеблока в регионе: <span style={{ color: '#1e6f3f' }}>{selectedRegion}</span>
          </label>
          
          <input 
            type="text" 
            placeholder="🔍 Введите название школы..." 
            value={searchTerm} 
            onChange={(e) => setSearchTerm(e.target.value)} 
            style={{ 
              width: '100%', 
              padding: '14px', 
              border: '1px solid #d1d5db', 
              borderRadius: '10px', 
              fontSize: '16px', 
              boxSizing: 'border-box', 
              marginBottom: '16px' 
            }} 
          />
          
          <div style={{ 
            maxHeight: '400px', 
            overflow: 'auto', 
            border: error && !value ? '2px solid #dc2626' : '1px solid #e5e7eb', 
            borderRadius: '10px', 
            padding: '12px', 
            background: '#f9fafb' 
          }}>
            {filteredBlocks.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                {searchTerm ? 'Ничего не найдено' : 'Нет пищеблоков в выбранном регионе'}
              </div>
            ) : (
              filteredBlocks.map(block => (
                <button 
                  key={block.Код} 
                  type="button" 
                  onClick={() => handleFoodBlockSelect(block.Код)} 
                  style={{ 
                    display: 'block', 
                    width: '100%', 
                    textAlign: 'left', 
                    padding: '14px', 
                    marginBottom: '10px', 
                    border: value === block.Код ? '2px solid #1e6f3f' : '1px solid #e5e7eb', 
                    borderRadius: '10px', 
                    background: value === block.Код ? '#e8f5e9' : 'white', 
                    cursor: 'pointer', 
                    transition: 'all 0.2s' 
                  }}
                >
                  <div style={{ fontWeight: 'bold', marginBottom: '6px', fontSize: '16px' }}>
                    🏫 {block.Наименование}
                    {value === block.Код && <span style={{ color: '#1e6f3f', marginLeft: '10px' }}>✓ Выбрано</span>}
                  </div>
                  <div style={{ fontSize: '13px', color: '#6b7280' }}>
                    {block.Район && <div>📍 {block.Район}</div>}
                    <div>🆔 Код: {block.Код}</div>
                  </div>
                </button>
              ))
            )}
          </div>
          
          {!value && (
            <div style={{ 
              marginTop: '16px', 
              padding: '12px', 
              background: '#fef3c7', 
              border: '1px solid #fde68a', 
              borderRadius: '10px', 
              color: '#92400e' 
            }}>
              ⚠️ Пожалуйста, выберите пищеблок из списка выше
            </div>
          )}
          
          {error && !value && (
            <div style={{ marginTop: '12px', color: '#dc2626', fontSize: '14px' }}>
              Пожалуйста, выберите пищеблок
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// StarRating с поддержкой disabled
function StarRating({ value, onChange, error, disabled = false }) {
  const stars = [2, 3, 4, 5];
  
  if (disabled) {
    return (
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
        {stars.map((star) => (
          <span key={star} style={{ fontSize: '44px', color: star <= value ? '#fbbf24' : '#d1d5db', opacity: 0.6 }}>★</span>
        ))}
        {value > 0 && <span style={{ marginLeft: '16px', color: '#6b7280', fontSize: '15px' }}>
          {value === 2 && 'Плохо'}{value === 3 && 'Удовлетворительно'}{value === 4 && 'Хорошо'}{value === 5 && 'Отлично'}
        </span>}
      </div>
    );
  }
  
  return (
    <div>
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
        {stars.map((star) => (
          <button key={star} type="button" onClick={() => onChange(star)} style={{ background: 'none', border: 'none', fontSize: '44px', cursor: 'pointer', padding: '4px', transition: 'transform 0.1s', color: star <= value ? '#fbbf24' : '#d1d5db', transform: star <= value ? 'scale(1.05)' : 'scale(1)' }}>
            ★
          </button>
        ))}
        {value > 0 && <span style={{ marginLeft: '16px', color: '#6b7280', fontSize: '15px' }}>{value === 2 && 'Плохо'}{value === 3 && 'Удовлетворительно'}{value === 4 && 'Хорошо'}{value === 5 && 'Отлично'}</span>}
      </div>
      {error && value === 0 && <div style={{ marginTop: '12px', color: '#dc2626', fontSize: '14px' }}>Пожалуйста, оцените</div>}
    </div>
  );
}